export type AccessEnded =
	| "access_unavailable"
	| "no_longer_has_access"
	| "institution_unreachable"
	| "workspace_unavailable"
	| "sign_in_unavailable";

export type AccessEndedNames = {
	workspace: string | null;
	homeOrganization: string | null;
};

const COPY = {
	access_unavailable: ({ workspace }) =>
		`Access to ${workspace ?? "this workspace"} is unavailable.`,
	no_longer_has_access: ({ workspace }) =>
		`You no longer have access to ${workspace ?? "this workspace"}.`,
	institution_unreachable: ({ homeOrganization }) =>
		`${homeOrganization ?? "Your institution"}'s system can't be reached right now.`,
	workspace_unavailable: ({ workspace }) =>
		`${workspace ?? "This workspace"} is unavailable.`,
	sign_in_unavailable: () => "Sign-in isn't available right now.",
} satisfies Record<AccessEnded, (names: AccessEndedNames) => string>;

const FROM_CODE = new Map<string, AccessEnded>([
	["organization_disconnected", "access_unavailable"],
	["entry_removed", "access_unavailable"],
	["workspace_not_linked", "access_unavailable"],
	["standing_gone", "no_longer_has_access"],
	["platform_standing_gone", "no_longer_has_access"],
	["platform_unreachable", "institution_unreachable"],
	["launch_unavailable", "sign_in_unavailable"],
]);

export const accessEndedFrom = (code: string): AccessEnded | null =>
	FROM_CODE.get(code) ?? null;

export const accessEndedWords = (
	ended: AccessEnded | null,
	names: AccessEndedNames
): string =>
	ended
		? COPY[ended](names)
		: `Something went wrong with ${names.workspace ?? "this workspace"}.`;
